(() => {
  const priceDc = document.getElementById('price-dc')
  if(!priceDc) return
  const dcSendAmount = priceDc.querySelector(".dc-sendamt")
  //dropdown elements
  const countryCurrencyDropdown = priceDc.querySelector("#country-currency-dropdown");
  const countryCurrencyDropdownInput = priceDc.querySelector("#country-currency-dropdown input.b-flag-select__search-field");
  const countryCurrencySpan = priceDc.querySelector("#country-currency-dropdown span.wu-input_input");
  const countryFlagDropdown = priceDc.querySelector("#country-currency-dropdown i.wu-flag");
  const countryCurrencyList = priceDc.querySelector("#country-currency-dropdown ul.country-currency-list");
  const priceDcLink = priceDc.querySelector(".price-dc-link")
  //input elements
  const countryCurrencyInput = priceDc.querySelector("#country-currency-input");
  const countryFlag = priceDc.querySelector("#country-currency-input i.wu-flag");
  const scriptFifo = document.getElementById("corridor_fifo");
  const inputEl = priceDc.querySelector("#country-currency-input span.wu-input_input");
  const dcFundsOut = priceDc.querySelector(".dc-fundsout");
  const dcFundsIn = priceDc.querySelector(".dc-fundsin")
  const dcAmountPaid = priceDc.querySelector(".dc-amtpaid")
  const dcAmountRecvd = priceDc.querySelector(".dc-amtrecvd")
  const r4Countries = window.pageData && window.pageData.R4_COUNTRIES;
  const isR4Country = r4Countries.indexOf(pageData.country.toUpperCase()) !== -1;
  const e1Countries = window.pageData && window.pageData.E1_COUNTRIES;
  const isE1Country = e1Countries.indexOf(pageData.country.toUpperCase()) !== -1;
  if(!scriptFifo || !inputEl || !countryFlag || !dcSendAmount || !dcFundsOut || !dcFundsIn || !dcAmountPaid || !dcAmountRecvd) return
 
  dcSendAmount.innerHTML = dcSendAmount.innerHTML.replace("{{send-amount}}", `<b>${dcSendAmount.getAttribute('data-amount')} ${pageData.senderCurrencyCode}</b>`)
  toggleClass(countryFlag, countryFlag.getAttribute('data-flag'), pageData.receiverCountryCode)
  countryFlag.setAttribute("data-flag", pageData.receiverCountryCode)
  inputEl.innerText = `${pageData.receiverCurrencyCode} - ${pageData.receiverCountryName}`;
  let fifo = JSON.parse(scriptFifo.innerHTML)
  let receiverCurrenciesList = window.pageData.receiverCurrencies;
  dcAmountPaid.setAttribute("data-amtpaid", dcAmountPaid.innerHTML);
  dcAmountRecvd.setAttribute("data-amtrecvd", dcAmountRecvd.innerHTML);
  dcFundsIn.setAttribute("data-fundsin", dcFundsIn.innerHTML);
  dcFundsOut.setAttribute("data-fundsout", dcFundsOut.innerHTML)
  const sendAmountValue = dcSendAmount.getAttribute("data-amount") || "1.00"
  // countryCurrencyDropdown.addEventListener('click', e => {
  //   e.preventDefault();
  //   toggleDropdown(countryCurrencyDropdown)
    
  // })
  dropdownFeature(countryCurrencyDropdown, false);
  
//   const toggleDropdown = (curDropdown) => {
  
//     if (curDropdown.classList.contains('d-none')) {
//         toggleClass(countryCurrencyList, 'd-none', 'd-block')
//         curDropdown.classList.add("wuds-dropdown--active")

//     } else {
//         toggleClass(countryCurrencyList, 'd-block', 'd-none')
//         curDropdown.classList.remove("wuds-dropdown--active")
//     }
// }
  if(receiverCurrenciesList.length > 1){
    countryFlagDropdown.classList.add(pageData.receiverCountryCode.toLowerCase())
    countryCurrencyInput.classList.add("d-none")
    countryCurrencyInput.classList.remove("d-flex")
    countryCurrencyDropdown.classList.remove("d-none");
    countryCurrencyDropdown.classList.add("d-block"); 
    countryCurrencyDropdownInput.setAttribute("value", `${receiverCurrenciesList[0]} - ${pageData.receiverCountryName}`)
    countryCurrencySpan.innerText = `${receiverCurrenciesList[0]} - ${pageData.receiverCountryName}`
    receiverCurrenciesList.forEach((obj) => {  
      let fragment = document.createDocumentFragment();
      let li = document.createElement('li');
      li.className = `wuds-dropdown__items b-flag-select__item `
      li.setAttribute('data-currency-value',obj)
      let currencyNameEL = document.createElement('span')
      currencyNameEL.className = `wuds-dropdown__item-text`
      currencyNameEL.innerText =  `${obj} - ${pageData.receiverCountryName}`
      let icon = document.createElement('i')
      icon.className = `wu-flag ${pageData.receiverCountryCode.toLowerCase()} wu-flagSize--S`
      li.appendChild(icon)
      li.appendChild(currencyNameEL)
      fragment.appendChild(li)
      countryCurrencyList.appendChild(fragment)
      li.addEventListener('mousedown', (e) => {
        countryCurrencyDropdownInput.setAttribute('value',`${obj} - ${pageData.receiverCountryName}`)
        countryFlagDropdown.classList.add(pageData.receiverCountryCode.toLowerCase())
        countryCurrencySpan.innerText = `${obj} - ${pageData.receiverCountryName}`;
        let href = priceDcLink.getAttribute( "href");
        let url = new URL(`https://www.westernunion.com${href}`)
        url.searchParams.set("ISOCurrency", obj);
        putValuesOnCurrencyUpdate(obj)
        priceDcLink.setAttribute( "href" , `${url.pathname}${url.search}`)
      })
    })
  }

  
  const putValuesOnCurrencyUpdate = (destinationCurrency) => {
    const reqPayload = {
        currency: pageData.senderCurrencyCode,
        country: pageData.country,
        funds_in: "*",
        host: `${window.location.origin}/`,
        sendAmount: sendAmountValue,
        sendToCurrency: destinationCurrency || pageData.receiverCurrencyCode,
        sendToCountry: pageData.receiverCountryCode
    }

    const reciverCountryCode = reqPayload.sendToCountry;
    const reciverCountryCurrency = reqPayload.sendToCurrency;
    reqPayload.sendToCurrency = setCountryCurrencyChange(
      reciverCountryCode.toUpperCase(),
      reciverCountryCurrency
    );
  
    let priceCatalogConfig = triggerPriceCatalog(reqPayload, false,true)
    dataCatalogProduct(
      false,
      window.pageData.country,
      window.pageData.language,
      {
        country: window.pageData.country,
        sendToCountry: pageData.receiverCountryCode,
        language: window.pageData.language,
        sendAmount: dcSendAmount.getAttribute("data-amount"),
        fund_in: "*"
      },
      priceCatalogConfig,
      true,
      destinationCurrency
    ).then((response) => {
      let filteredResp = (isR4Country || isE1Country)
        ? response
        : priceCatalogConfig.initApi(response);

      console.log(filteredResp);
      let dataRes = filteredResp || {
        fx: null,
        fee: null,
        receiveAmount: 0,
        sendAmount: 0,
      };

      dataRes.receiveAmount = dataRes.receiveAmount?.toFixed(2);
      dcAmountPaid.innerHTML = dcAmountPaid
        .getAttribute("data-amtpaid")
        .replace(
          "{{amount paid}}",
          `<b>${+parseFloat(sendAmountValue) + dataRes.fee} ${
            pageData.senderCurrencyCode
          }</b>`
        );
      dcAmountRecvd.innerHTML = dcAmountRecvd
        .getAttribute("data-amtrecvd")
        .replace(
          "{{recvAmount}}",
          `<b>${dataRes.receiveAmount} ${destinationCurrency || pageData.receiverCurrencyCode}</b>`
        );
    const fundsOutFromApi = dataRes.payOut || dataRes.serviceCode 
    const fundInFromApi = dataRes.fundsIn || dataRes.selectedFundsIn   
    dcFundsOut.innerHTML = dcFundsOut.getAttribute("data-fundsout")
      .replace(
        "{{funds_out}}",
        `<b>${fifo.fundsOut[fundsOutFromApi] || ''}</b>`
      );
      dcFundsIn.innerHTML = dcFundsIn.getAttribute("data-fundsin").replace(
        "{{funds_in}}",
        `<b>${fifo.fundsIn[fundInFromApi.toLowerCase()] || ''}</b>`
      );
      let href = priceDcLink.getAttribute("href");
      href = href.split("?")[0];
      let fundsOut;
      for (let payOutType in CloudPayOutCodeMapping) {
        if (CloudPayOutCodeMapping[payOutType] === fundsOutFromApi) {
          fundsOut = payOutType.split("_")[0]
        }
      }
      priceDcLink.setAttribute(
        "href",
        `${href}?ReceiveCountry=${pageData.receiverCountryCode.toUpperCase()}&ISOCurrency=${destinationCurrency || pageData.receiverCurrencyCode.toUpperCase()}&SendAmount=${dcSendAmount.getAttribute(
          "data-amount"
        )}&FundsOut=${fundsOut}&FundsIn=${CloudPayIn[fundInFromApi]}`
      );
    });
  }
  putValuesOnCurrencyUpdate()
})()